import React, { useEffect, useState } from "react";
import { Layout } from "antd";
import {
  StompSessionProvider,
  useSubscription,
  useStompClient,
} from "react-stomp-hooks";
import { IAppointmentsDataTypeInput } from "../Appointments/AppointmentController";
import { IAppointmentsDataType } from "../../redux/reduxAppointments/appointmentsSlice";
import dayjs from "dayjs";
import { getAppointments } from "../networkCalls";
import {
  doctorColumnOrder,
  doctorKanbanColumns,
} from "./DoctorAppointmentKanban/doctorKanbanConstants";
import { ColumnType } from "../Appointments/AppointmentsKanban/appointmentsConstants";
import { AppointmentKanban } from "../Appointments/AppointmentsKanban/AppointmentsKanban";
import { responseObject, showToastType } from "../utils";
import background from "../../bg-image-4.jpg";
import timezone from "dayjs/plugin/timezone";
import { toast } from "react-toastify";
import utc from "dayjs/plugin/utc";
import config from "../../config/config";
import { useAuth } from "../../hooks/useAuth";
const { Content } = Layout;
dayjs.extend(utc);
dayjs.extend(timezone);

export function DoctorScreenController() {
  const { token } = useAuth();
  return (
    <Content
      style={{
        backgroundImage: `url(
        ${background}
        )`,
      }}
      className="bg-fixed"
    >
      <StompSessionProvider
        url={
          config.WEB_SOCKET_ENDPOINT === undefined
            ? "ws://localhost:8000/websocket"
            : config.WEB_SOCKET_ENDPOINT
        }
        connectHeaders={{
          Authorization: "Bearer " + String(token ?? ""),
        }}
      >
        <DoctorSubscriber />
      </StompSessionProvider>
    </Content>
  );
}

function DoctorSubscriber() {
  const [appointmentsData, setAppointmentsData] = useState<
    Array<IAppointmentsDataType>
  >([]);
  const [columnOrderState, setcolumnOrderState] =
    useState<string[]>(doctorColumnOrder);
  const [columnsData, setColumnsData] = useState<{
    [columnId: string]: ColumnType;
  }>(doctorKanbanColumns);
  const stompClient = useStompClient();

  useEffect(() => {
    (async () => {
      if (appointmentsData.length === 0) {
        const appointmentResponseObject: responseObject =
          await getAppointments();
        const message = appointmentResponseObject["message"];
        const status = appointmentResponseObject["statusCode"];
        showToastType(message, status);
        const appointments = appointmentResponseObject[
          "data"
        ] as Array<IAppointmentsDataTypeInput>;

        setAppointmentsData(formatAppointments(appointments));
      }
    })();
  }, []);

  useSubscription("/topic/appointments", (message) => {
    console.log(message);
    var appointments = JSON.parse(message.body);
    console.log(appointments);
    console.log("WS Server sent event");
    // console.log("appointments" in appointments);
    if ("appointments" in appointments) {
      const appointmentsArray: Array<IAppointmentsDataTypeInput> =
        appointments["appointments"];
      showToastType("Retrieved latest Appointments", 200);
      setAppointmentsData(formatAppointments(appointmentsArray));
    }
  });
  function formatAppointments(
    rawAppointments: Array<IAppointmentsDataTypeInput>
  ) {
    return rawAppointments.map((appointment) => {
      return {
        ...appointment,
        createdAt: dayjs.utc(appointment["createdAt"]).local().toISOString(),
        endDateTime: dayjs
          .utc(appointment["endDateTime"])
          .local()
          .toISOString(),
        startDateTime: dayjs
          .utc(appointment["startDateTime"])
          .local()
          .toISOString(),
        updatedAt: dayjs.utc(appointment["updatedAt"]).local().toISOString(),
      };
    });
  }

  return (
    <div style={{ overflowX: "auto" }}>
      <AppointmentKanban
        columnOrdering={columnOrderState}
        columnsData={columnsData}
        appointmentsData={appointmentsData}
      />
    </div>
  );
}
